import React from "react";
import { navigate } from "@reach/router";
import Session from "../components/Session";
import LoadingState from "../components/states/LoadingState";
import fetchFromApi from "../utils/fetchFromApi";
import Config from "../config";
import ErrorState from "../components/states/ErrorState";
import Message from "../components/modals/Message";
import Modal from "../components/modals/Modal";
import Confetti from "react-confetti";

class TrialRestart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLoading: true,
      error: false,
      success: false,
      loading: false,
    };
  }

  componentDidMount = async () => {
    document.title = `Templates ${Config.titleSuffix}`;
    this._isMounted = true;
    await Session.refreshUserData();

    const user = await Session.getUserData();

    if (!user?.org) {
      navigate("/choose-organisation?redirect=/");
      return;
    }

    this.setState({ pageLoading: false, user });
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleTrialExtend = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    const path = "/admin/organisations/trial-restart";

    try {
      await fetchFromApi(path, this.props.location.pathname);

      this.setState({
        loading: false,
        success: true,
      });
      await Session.refreshUserData();
    } catch (error) {
      this.setState({
        loading: false,
        error: true,
        errorDetails: {
          title: "Could not extend trial",
          message:
            typeof error === "string"
              ? error
              : "We were unable to extend your trial. Please try again.",
        },
      });
    }
  };

  render() {
    if (this.state.pageLoading) {
      return <LoadingState />;
    }

    const org = this.state.user.org;

    if (org.plan !== "free") {
      return (
        <ErrorState
          h1="Error"
          message="Only users on a free plan are eligible to start a new trial."
          continueUrl="/"
          fullPage={true}
        />
      );
    }
    return (
      <>
        <Message
          open={this.state.loading}
          type="loading"
          title="Restarting Trial..."
        />
        <Modal
          open={this.state?.error}
          type="error"
          title={this.state.errorDetails?.title}
          message={this.state.errorDetails?.message}
          setClose={() => {
            this.setState({ error: false }),
              setTimeout(() => this.setState({ errorDetails: false }), 500);
          }}
        />
        <div className="flex flex-row items-center justify-center max-w-screen-xl min-h-screen mx-auto">
          {this.state.success ? (
            <div className="flex flex-col w-full max-w-sm">
              <Confetti
                className="w-screen h-screen"
                colors={["#fbbf24", "#fcd34d", "#fde68a"]}
                numberOfPieces={1000}
                runTime={5000}
                recycle={false}
                drawShape={(ctx) => {
                  ctx.beginPath();
                  ctx.rect(-5, -5, 10, 10);
                  ctx.fill();
                  ctx.closePath();
                }}
              />
              <h2 className="text-2xl text-center">Success</h2>

              <p className="mb-4 font-light text-center">
                Your trial has been successfully restarted. You can now use
                LinePilot Pro for another 14 days.
              </p>
              <div className="flex text-center">
                <a className="mx-auto button-primary" href="/">
                  Continue
                </a>
              </div>
            </div>
          ) : (
            <div className="flex flex-col w-full max-w-sm">
              <h2 className="text-2xl text-center">Start a new Trial</h2>

              <p className="mb-4 font-light text-center">
                Activate a new 14 day trial of LinePilot Pro.
              </p>
              <div className="flex text-center">
                <button
                  className="mx-auto button-primary"
                  onClick={this.handleTrialExtend}
                >
                  Activate
                </button>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default TrialRestart;
